import React from 'react';
import PropTypes from 'prop-types';
import { getImagePath } from '../utils/imageOptimization';
import '../styles/gallery-card.css';

function GalleryCard({ photo, onClick, folder = 'photography' }) {
  const imagePath = getImagePath(photo.imageName, 'full', folder);

  return (
    <div className="gallery-card" onClick={() => onClick(photo)}>
      <picture>
        <img
          src={imagePath}
          alt={photo.title}
          loading="lazy"
        />
      </picture>
      <div className="card-overlay">
        <div className="card-title">{photo.title}</div>
        <div className="card-date">{photo.date}</div>
      </div>
    </div>
  );
}

GalleryCard.propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    imageName: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  folder: PropTypes.string
};

export default GalleryCard;
